import { computed, defineComponent, ref, useContext, useCssModule } from '@nuxtjs/composition-api';
import { getWealthTitle } from '~/utils';
export default defineComponent({
    name: 'RatingTooltip',
    props: {
        flink: {
            default: null,
            type: Object,
        },
    },
    setup(props) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        /**
         * Context.
         */
        const context = useContext();
        /**
         * Viewport.
         */
        const viewport = context.$viewport;
        const rootEl = ref();
        const liveTimeout = ref(0);
        const isVisible = ref(false);
        const lastRating = computed(() => props.flink.ratings[0] || {});
        function handleClick() {
            isVisible.value = !isVisible.value;
        }
        function handleMouseenter() {
            if (viewport.isLessThan('tablet')) {
                return;
            }
            clearTimeout(liveTimeout.value);
            isVisible.value = true;
        }
        function handleMouseleave() {
            if (viewport.isLessThan('tablet')) {
                return;
            }
            clearTimeout(liveTimeout.value);
            liveTimeout.value = window.setTimeout(() => {
                isVisible.value = false;
            }, 300);
        }
        return {
            css,
            viewport,
            lastRating,
            isVisible,
            handleClick,
            handleMouseenter,
            handleMouseleave,
            getWealthTitle,
            rootEl,
        };
    },
});
